export function isNumberAlmostEqual(a: number, b: number, epsilon = 1e-6): boolean {
  return Math.abs(a - b) < epsilon;
}

export function isAlmostEqual(a: Obj, b: Obj, epsilon = 1e-6): boolean {
  if (typeof a !== typeof b) {
    return false;
  }

  if (typeof a === `number` && typeof b === `number`) {
    return isNumberAlmostEqual(a, b, epsilon);
  }

  if (typeof a === `object` && typeof b === `object`) {
    const keysA = new Set(Object.keys(a));
    const keysB = new Set(Object.keys(b));

    if (keysA.size !== keysB.size) {
      return false;
    }

    for (const key of keysA) {
      if (!keysB.has(key) || !isAlmostEqual(a[key], b[key], epsilon)) {
        return false;
      }
    }
    return true;
  }

  return a === b;
}
